import { render, staticRenderFns } from "./EditTrainingProgramApplicationQuestionPage.vue?vue&type=template&id=2036be1a&"
import script from "./EditTrainingProgramApplicationQuestionPage.vue?vue&type=script&lang=js&"
export * from "./EditTrainingProgramApplicationQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
